import { HttpServiceResponse } from '../../shared'
import { AccountAddActions } from '../models/account.types'
import { AccountAddParams } from '../models/add-params.model'
import AbstractAccountProvider from './account-abstract.provider'

export class AccountAddProvider extends AbstractAccountProvider {
  urlPath = 'acc_account_add_api'

  public add<T>(action: AccountAddActions, params: Partial<AccountAddParams>): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      action,
      ...params,
    })

    return this.http.post(`${this.url}?${query}`)
  }
}
